import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { LangService } from 'src/app/core/services/lang.service';
import { CommonService } from '../../../services/common.service';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { DataService } from '../../../services/forms/cheque-register/data.service';
import { ChequeType } from '../../../models/cheque-type.model';
import { AlertService } from 'src/app/shared/popup/service/alert.service';
import { DataLoadService } from 'src/app/shared/services/data-load.service';

@Component({
    selector: 'app-accounts-list',
    templateUrl: './../../../templates/forms/modals/cheque-type-list.component.html',
})
export class ChequeTypeListComponent implements OnInit {
    @Input()
    config: any;

    @Input()
    modalShow: boolean = true;

    @Output()
    submit: EventEmitter<any> = new EventEmitter<any>();

    dataObj: any;

    chequeTypeList: any[] = [];
    searchFields: any[] = ['STATUS'];
    public searchString;

    constructor(public langService: LangService, private dataLoadService: DataLoadService, private dataService: DataService, private alertService: AlertService) { }

    ngOnInit() {
        this.dataLoadService.load("FG_AC_COMM_BANK_CHEQUE_INFO",{
            P_CHEQUE_AUTHO_NO: null,
            P_CHECK_NO: null,
            P_ACC_NO: null,
            P_CHECKID: null,
            P_CHECKBOOK_ID: null,
            P_QUERYOPTIONS: fixedValues.queryOptions.PaidTo,
        }).subscribe(arg => { this.chequeTypeList = arg.body });
    }
    onClickAddNewChequeType() {
        this.chequeTypeList.push(new ChequeType());
    }

    onClickRemoveChequeType(index, cheque) {
        if (cheque.SQL_STATE == 1) {
            this.chequeTypeList.splice(index, 1);
        }
        else {
            cheque.SQL_STATE = fixedValues.sqlState.sqlDelete;
        }
    }
    onClickSaveChequeType() {
        this.alertService.info("Do you want to save Cheque Prepare?", true).then(data => {
            if (data) {
                this.dataService.saveChequeStat(this.chequeTypeList).subscribe(arg => {
                    this.alertService.success("Cheque Type saved successfully");
                }), err => {
                    this.alertService.warning("Failed to save Cheque Type!");
                };
            }
        })
    }

}
